export function resolveAvatarSrc(userId?: string, avatar?: string): string | undefined {
  if (!avatar) {
    return undefined;
  }
  if (avatar.startsWith("gs://")) {
    if (!userId) {
      return undefined;
    }
    return `/v1/profiles/${encodeURIComponent(userId)}/avatar`;
  }
  return avatar;
}
